export const painPoints = [
  {
    emoji: '🤔',
    title: '“What do I have to do now?”',
    desc: 'You need to repeat several times what the next activity is, every single day, for every single step.',
  },
  {
    emoji: '🔁',
    title: 'Transitions are a battle',
    desc: 'Going out, showering, putting away toys or going to bed requires many reminders before anything actually happens.',
  },
  {
    emoji: '🧠',
    title: 'Everything depends on you',
    desc: "The routine lives in your head and you're the one who has to remember what comes next, all day long.",
  },
  {
    emoji: '🌀',
    title: 'The day feels chaotic',
    desc: "The activities exist, but they're not always presented in a way your child can easily visualize and follow.",
  },
];
